export default __webpack_public_path__ + "static/media/Invited.34265574.svg";